var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteeyeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3C4.76055 3 3.01602 4.33438 0.875 6.5C2.71797 8.35117 4.26562 10 7 10C9.73164 10 11.7414 7.91094 13.125 6.53828C11.7086 4.93047 9.70156 3 7 3ZM7 8.99648C5.64922 8.99648 4.55 7.87539 4.55 6.5C4.55 5.12187 5.64922 4.00352 7 4.00352C8.35078 4.00352 9.45 5.12461 9.45 6.5C9.45 7.87813 8.35078 8.99648 7 8.99648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9999 6.12499C6.9999 5.90898 7.0792 5.7121 7.20772 5.55898C7.13936 5.54804 7.071 5.54257 6.9999 5.54257C6.2124 5.54257 5.56982 6.19609 5.56982 6.99999C5.56982 7.8039 6.2124 8.45742 6.9999 8.45742C7.7874 8.45742 8.42998 7.8039 8.42998 6.99999C8.42998 6.9371 8.42451 6.87421 8.41904 6.81132C8.26865 6.9289 8.08272 6.99999 7.87764 6.99999C7.39092 6.99999 6.9999 6.60898 6.9999 6.12499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteeyeicon);
export default __webpack_public_path__ + "static/media/whiteeyeicon.e83c7cfa21e64c4f23073eac9ad4df98.svg";
export { ForwardRef as ReactComponent };